var CarouselStore = /** @class */ (function () {
    function CarouselStore(options) {
        var _this = this;
        this.initialPage = 0;
        /** @internal */
        this.connect = function (carousel) {
            if (!_this.carousel && _this.initialPage !== 0)
                carousel.preselectPage(_this.initialPage);
            _this.carousel = carousel;
        };
        Object.assign(this, options);
    }
    Object.defineProperty(CarouselStore.prototype, "activePage", {
        get: function () {
            if (!this.carousel)
                return this.initialPage;
            return this.carousel.activePage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CarouselStore.prototype, "totalPages", {
        get: function () {
            if (!this.carousel)
                return 0;
            return this.carousel.snaps.pages.length;
        },
        enumerable: true,
        configurable: true
    });
    CarouselStore.prototype.has = function (index) {
        return index >= 0 && index < this.totalPages;
    };
    CarouselStore.prototype.hasNext = function () {
        return this.has(this.activePage + 1);
    };
    CarouselStore.prototype.hasPrevious = function () {
        return this.has(this.activePage - 1);
    };
    CarouselStore.prototype.goTo = function (index) {
        if (!this.carousel)
            return (this.initialPage = index);
        return this.has(index) && this.carousel.goTo(index);
    };
    CarouselStore.prototype.goNext = function () {
        return this.goTo(this.activePage + 1);
    };
    CarouselStore.prototype.goPrevious = function () {
        return this.goTo(this.activePage - 1);
    };
    CarouselStore.prototype.isActive = function (childIndex) {
        if (!this.carousel)
            return false;
        return this.carousel.isActive(childIndex);
    };
    return CarouselStore;
}());
export { CarouselStore };
